<template>
  <div class="modal fade" id="riwayatPOModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content border-0 shadow-lg" style="border-radius: 20px; overflow: hidden;">
        <!-- Header -->
        <div class="modal-header border-0 bg-white px-4 pt-4 pb-0">
          <h5 class="modal-title d-flex align-items-center fw-bold text-dark">
            Riwayat PO - {{ memberName }}
          </h5>
          <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <!-- Body -->
        <div class="modal-body p-4" style="background-color: #f8f9fa; max-height: 70vh; overflow-y: auto;">
          <div v-if="loading" class="text-center py-5">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-2 text-muted">Memuat riwayat...</p>
          </div>

          <div v-else-if="orders.length === 0" class="text-center py-5">
            <vue-feather type="shopping-bag" class="text-muted mb-3" style="width: 48px; height: 48px;"></vue-feather>
            <p class="text-muted">Belum ada riwayat Purchase Order.</p>
          </div>

          <div v-else>
            <!-- Loop through each Order -->
            <div v-for="order in orders" :key="order.id" class="order-group mb-5">
              <!-- Order Accordion/Summary -->
              <div class="card border-0 shadow-sm mb-3" style="border-radius: 12px; overflow: hidden;">
                <div class="card-header border-0 bg-white p-3 d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center">
                    <div class="order-number-circle bg-dark me-3 text-white fw-bold" style="background-color: #0d2137 !important;">
                      #{{ order.id }}
                    </div>
                    <div>
                      <h6 class="mb-0 fw-bold">Purchase Order #{{ order.id }}</h6>
                      <small class="text-muted">
                        <vue-feather type="calendar" class="me-1" style="width: 12px;"></vue-feather>
                        {{ formatDate(order.tanggal_order) }}
                      </small>
                    </div>
                  </div>
                  <div class="d-flex align-items-center gap-3">
                    <span :class="statusBadgeClass(order.calculatedStatus)">
                      {{ order.calculatedStatus.toUpperCase() }}
                    </span>
                    <vue-feather type="chevron-down" class="text-muted" style="width: 18px;"></vue-feather>
                  </div>
                </div>
                <!-- Separation Line -->
                <div style="height: 2px; background: linear-gradient(to right, #0d2137, #1a237e);"></div>
                
                <div class="card-body bg-white p-4">
                  <!-- Timeline -->
                  <div class="timeline">
                    <!-- Step 1: Pesanan Dibuat -->
                    <div class="timeline-item">
                      <div class="timeline-marker" style="background-color: #0d2137;">
                        <vue-feather type="shopping-bag" style="width: 14px; color: white;"></vue-feather>
                      </div>
                      <div class="timeline-content card border-0 shadow-sm ps-0 overflow-hidden" style="border-left: 4px solid #0d2137;">
                        <div class="p-3">
                          <div class="d-flex justify-content-between align-items-start mb-2">
                            <div>
                              <h6 class="fw-bold mb-1">Pesanan Dibuat (PO)</h6>
                              <small class="text-muted d-block">
                                <vue-feather type="calendar" class="me-1" style="width: 12px;"></vue-feather>
                                {{ formatDate(order.tanggal_order) }}
                              </small>
                            </div>
                            <span class="text-dark x-small fw-bold" style="color: #0d2137 !important;">Created</span>
                          </div>
                          
                          <div class="mt-3">
                            <div v-for="item in order.details" :key="item.id" class="d-flex justify-content-between align-items-center py-1">
                              <span class="small fw-semibold text-muted text-uppercase">{{ item.product_nama }}</span>
                              <span class="small fw-bold text-dark">{{ item.quantity_box }} Box</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Step 2+: Shipments -->
                    <div v-for="(shipment, index) in order.shipments" :key="shipment.id" class="timeline-item">
                      <div class="timeline-marker bg-warning">
                        <vue-feather type="truck" style="width: 14px; color: white;"></vue-feather>
                      </div>
                      <div class="timeline-content card border-0 shadow-sm ps-0 overflow-hidden" style="border-left: 4px solid #fd7e14;">
                        <div class="p-3">
                          <div class="d-flex justify-content-between align-items-start mb-2">
                            <div>
                              <h6 class="fw-bold mb-1">Realisasi Pengiriman Tahap {{ index + 1 }}</h6>
                              <small class="text-muted d-block">
                                <vue-feather type="calendar" class="me-1" style="width: 12px;"></vue-feather>
                                {{ formatDate(shipment.tanggal_pengiriman) }}
                              </small>
                              <small class="text-muted mt-1 d-block">Surat Jalan: {{ shipment.no_surat_jalan || '-' }}</small>
                            </div>
                            <span class="text-warning x-small fw-bold">Shipping</span>
                          </div>
                          
                          <div class="mt-3">
                            <div v-for="sItem in shipment.items" :key="sItem.id" class="d-flex justify-content-between align-items-center py-1">
                              <span class="small fw-semibold text-muted text-uppercase">{{ sItem.product_nama }}</span>
                              <span class="small fw-bold text-dark">{{ sItem.qty_shipped }} Box</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Final Step: Completed (if status is completed) -->
                    <div v-if="order.calculatedStatus === 'completed'" class="timeline-item">
                      <div class="timeline-marker bg-success">
                        <vue-feather type="check" style="width: 14px; color: white;"></vue-feather>
                      </div>
                      <div class="timeline-content card border-0 shadow-sm ps-0 overflow-hidden" style="border-left: 4px solid #198754;">
                        <div class="p-3">
                          <div class="d-flex justify-content-between align-items-center">
                            <h6 class="fw-bold mb-0">Pesanan Selesai</h6>
                            <span class="text-success x-small fw-bold">Done</span>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer border-0 px-4 pb-4">
          <button type="button" class="btn btn-dark w-100 py-3 fw-bold shadow-sm" style="border-radius: 12px;" data-bs-dismiss="modal">
            Tutup
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue';
import orderService from '@/services/orderService';
import shipmentService from '@/services/shipmentService';

export default {
  props: {
    memberId: {
      type: [Number, String],
      required: true
    },
    memberName: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const orders = ref([]);
    const loading = ref(true);

    const loadHistory = async () => {
      if (!props.memberId) return;
      
      loading.value = true;
      try {
        // 1. Get all orders for this member
        const poData = await orderService.getOrders({ member_id: props.memberId, limit: 100 });
        const poList = Array.isArray(poData) ? poData : (poData?.items || []);
        
        // 2. Sort by ID descending (newest first)
        poList.sort((a, b) => b.id - a.id);

        // 3. For each order, get full details and shipments
        const fullOrders = await Promise.all(poList.map(async (o) => {
          const detail = await orderService.getOrder(o.id);
          const ships = await shipmentService.getShipmentsByOrder(o.id);
          
          // Calculate status based on items
          const items = detail.details || [];
          const shippedMap = {};
          ships.forEach(s => {
            s.items.forEach(si => {
              if (!shippedMap[si.order_detail_id]) shippedMap[si.order_detail_id] = 0;
              shippedMap[si.order_detail_id] += si.qty_shipped;
            });
          });

          let totalShipped = 0;
          let totalOrdered = 0;
          items.forEach(item => {
            totalOrdered += item.quantity_box;
            totalShipped += (shippedMap[item.id] || 0);
          });

          let calcStatus = 'processing';
          if (totalOrdered > 0 && totalShipped >= totalOrdered) calcStatus = 'completed';
          else if (totalShipped > 0) calcStatus = 'partial';
          if (o.status === 'draft') calcStatus = 'draft';

          return {
            ...detail,
            shipments: ships,
            calculatedStatus: calcStatus
          };
        }));

        orders.value = fullOrders;
      } catch (error) {
        console.error("Failed to load PO history", error);
      } finally {
        loading.value = false;
      }
    };

    const formatDate = (dateStr) => {
      if (!dateStr) return "-";
      return new Date(dateStr).toLocaleDateString('id-ID', {
        day: '2-digit',
        month: 'long',
        year: 'numeric'
      });
    };

    const statusBadgeClass = (status) => {
      switch(status) {
        case 'completed': return 'badge rounded-pill bg-success px-3 py-2';
        case 'partial': return 'badge rounded-pill bg-warning text-dark px-3 py-2';
        case 'processing': return 'badge rounded-pill bg-primary px-3 py-2';
        default: return 'badge rounded-pill bg-secondary px-3 py-2';
      }
    };

    onMounted(() => {
        if (props.memberId) {
            loadHistory();
        }
    });

    watch(() => props.memberId, (newMemberId) => {
      if (newMemberId) {
        loadHistory();
      } else {
        orders.value = []; // Clear orders if memberId becomes null/undefined
      }
    });

    return {
      orders,
      loading,
      loadHistory,
      formatDate,
      statusBadgeClass
    };
  }
};
</script>

<style scoped>
.order-number-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  box-shadow: 0 4px 10px rgba(13, 110, 253, 0.3);
}

.x-small {
  font-size: 11px;
}

/* Timeline Styles */
.timeline {
  position: relative;
  padding-left: 50px;
  margin-left: 5px;
}

.timeline::before {
  content: '';
  position: absolute;
  left: 17px;
  top: 5px;
  bottom: 5px;
  width: 2px;
  background-color: #e9ecef;
}

.timeline-item {
  position: relative;
  margin-bottom: 30px;
}

.timeline-item:last-child {
  margin-bottom: 0;
}

.timeline-marker {
  position: absolute;
  left: -48px;
  top: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  border: 4px solid white;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.timeline-content {
  border-radius: 12px;
  background: white;
  transition: transform 0.2s;
}

.timeline-content:hover {
  transform: translateY(-2px);
}

/* Custom Scrollbar */
.modal-body::-webkit-scrollbar {
  width: 6px;
}
.modal-body::-webkit-scrollbar-track {
  background: transparent;
}
.modal-body::-webkit-scrollbar-thumb {
  background: #dee2e6;
  border-radius: 10px;
}
.modal-body::-webkit-scrollbar-thumb:hover {
  background: #adb5bd;
}
</style>
